"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const forms_1 = require("@angular/forms");
const file_manager_service_1 = require("../../../service/file-manager.service");
const core_2 = require("@ngx-translate/core");
const material_1 = require("@angular/material");
const map_service_1 = require("../../../commons/map.service");
const _4d_mapper_1 = require("4d-mapper");
const router_1 = require("@angular/router");
const app_service_1 = require("../../../commons/app.service");
const http_1 = require("@angular/common/http");
const merge_1 = require("rxjs/observable/merge");
const of_1 = require("rxjs/observable/of");
const catchError_1 = require("rxjs/operators/catchError");
const map_1 = require("rxjs/operators/map");
const startWith_1 = require("rxjs/operators/startWith");
const switchMap_1 = require("rxjs/operators/switchMap");
const Subject_1 = require("rxjs/Subject");
const operators_1 = require("rxjs/operators");
class EpsgcodeDialog {
    constructor(fourD, service, r, sn, d, ar, t, trans, fb, cd, fileManager, dialogRef, snackBar, mapService, data, httpClient) {
        this.fourD = fourD;
        this.service = service;
        this.r = r;
        this.ar = ar;
        this.t = t;
        this.trans = trans;
        this.fb = fb;
        this.cd = cd;
        this.fileManager = fileManager;
        this.dialogRef = dialogRef;
        this.snackBar = snackBar;
        this.mapService = mapService;
        this.data = data;
        this.httpClient = httpClient;
        this.searchEPSGControll = new forms_1.FormControl();
        this.options = [];
        this.displayedColumns = ['name', 'epsg'];
        this.datas = [];
        this.resultsLength = 0;
        this.isLoadingResults = false;
        this.isRateLimitReached = false;
        this.searchStrChange = new Subject_1.Subject();
        this.subs = [];
        this.selectedRowIndex = -1;
        // super(service, r, sn, d);
    }
    onRowClicked(row) {
        // console.log('Row clicked: ', row);
        this.selectedRowIndex = row.id;
        this.selectedEPSGCode = row;
    }
    ngOnInit() {
        this.searchEPSGControll.valueChanges.pipe(operators_1.debounceTime(1000)).subscribe(s => {
            this.searchStr = s;
            this.paginator.pageIndex = 0;
            this.searchStrChange.next();
        });
    }
    ngAfterViewInit() {
        // If the user changes the sort order, reset back to the first page.
        this.subs.push(this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0));
        this.subs.push(merge_1.merge(this.sort.sortChange, this.paginator.page, this.searchStrChange)
            .pipe(startWith_1.startWith({}), switchMap_1.switchMap(() => {
            this.isLoadingResults = true;
            return this.onInputChanged();
        }), map_1.map(data => {
            this.isLoadingResults = false;
            this.isRateLimitReached = false;
            this.resultsLength = data.total;
            return data.items;
        }), catchError_1.catchError(() => {
            this.isLoadingResults = false;
            this.isRateLimitReached = true;
            return of_1.of([]);
        })).subscribe(datas => {
            this.selectedRowIndex = -1;
            this.datas = datas;
        }));
        if (this.data.incoming) {
            setTimeout(() => { this.searchEPSGControll.setValue(this.data.incoming); }, 200);
        }
    }
    onInputChanged() {
        let search = this.fourD.V.searchByObject(_4d_mapper_1.EPSGCodes)
            .sortBy(this.sort.active, this.sort.direction === 'desc' ? true : false)
            .offset(this.paginator.pageIndex * this.paginator.pageSize)
            .limit(this.paginator.pageSize);
        // .notEquals('desc', ''); // filter out the desc == null
        if (this.searchStr) {
            return search.contains('name', this.searchStr).queryObservable();
        }
        else {
            return search.queryObservable();
        }
    }
    setDefaultEPSGCode() {
        this.fourD.V.searchByObject(_4d_mapper_1.EPSGCodes).equals('uid', '4326').queryObservable().subscribe(value => {
            this.dialogRef.close(value.items[0]);
        });
    }
    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }
}
exports.EpsgcodeDialog = EpsgcodeDialog;
